import { useCallback } from 'react';
import { useAppDispatch } from '@/store/hooks';
import { showAlertDialog, type ShowAlertDialogPayload } from '@/store/slices/alertDialogSlice';

/**
 * Returns `alert(message, opts?)` — a drop-in replacement for `window.alert` that opens the
 * global GGC alert modal instead of the browser dialog. `opts` can override title/tone/label
 * (e.g. `{ tone: 'success' }`). For a full payload, `dispatch(showAlertDialog(...))` also works.
 */
export function useAlert() {
  const dispatch = useAppDispatch();
  return useCallback(
    (message: string, opts?: Omit<ShowAlertDialogPayload, 'message'>) =>
      dispatch(showAlertDialog({ message, ...opts })),
    [dispatch],
  );
}
